/**
 * AV API
 * AV for GWR Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CodeEntry } from './codeEntry';
import { HistInfo } from './histInfo';
import { BodenbedeckungVersionId } from './bodenbedeckungVersionId';
import { AvMutation } from './avMutation';


export interface BodenbedeckungVersionDetailEntry { 
    id?: BodenbedeckungVersionId;
    histInfo?: HistInfo;
    bodenbedeckungArt?: BodenbedeckungVersionDetailEntry.BodenbedeckungArtEnum;
    sortIndex?: number;
    codeBodenbedeckungArt?: CodeEntry;
    flaecheQuadratmeter?: number;
    bodenbedeckungArtZusatz?: string;
    herkunftAnteilLN?: string;
    anteilLNBestockteFlaecheQuadratmeter?: number;
    mutationsNummer?: AvMutation;
}
export namespace BodenbedeckungVersionDetailEntry {
    export type BodenbedeckungArtEnum = 'GEBAEUDE' | 'BEFESTIGT_STRASSE_WEG' | 'BEFESTIGT_TROTTOIR' | 'BEFESTIGT_VERKEHRSINSEL' | 'BEFESTIGT_BAHN' | 'BEFESTIGT_FLUGPLATZ' | 'BEFESTIGT_WASSERBECKEN' | 'BEFESTIGT_UEBRIGE_BEFESTIGTE' | 'HUMUSIERT_ACKER_WIESE_WEIDE' | 'HUMUSIERT_INTENSIVKULTUR_REBEN' | 'HUMUSIERT_INTENSIVKULTUR_UEBRIGE_INTENSIVKULTUR' | 'HUMUSIERT_GARTENANLAGE' | 'HUMUSIERT_HOCH_FLACHMOOR' | 'HUMUSIERT_UEBRIGE_HUMUSIERTE' | 'GEWAESSER_STEHENDES' | 'GEWAESSER_FLIESSENDES' | 'GEWAESSER_SCHILFGUERTEL' | 'BESTOCKT_GESCHLOSSENER_WALD' | 'BESTOCKT_WYTWEIDE_WYTWEIDE_DICHT' | 'BESTOCKT_WYTWEIDE_WYTWEIDE_OFFEN' | 'BESTOCKT_UEBRIGE_BESTOCKTE' | 'VEGETATIONSLOS_FELS' | 'VEGETATIONSLOS_GLETSCHER_FIRN' | 'VEGETATIONSLOS_GEROELL_SAND' | 'VEGETATIONSLOS_ABBAU_DEPONIE' | 'VEGETATIONSLOS_UEBRIGE_VEGETATIONSLOSE' | 'GEBAEUDE_HOFRAUM_GARTEN_ANLAGE_BISHER' | 'STRASSE_WEG_TROTTOIR_RAV' | 'BAHNEN_STRASSEN_WEGE_BISHER' | 'ACKER_WIESE_PFLANZLAND_BAUMGARTEN_BISHER' | 'WEIDEN_BISHER' | 'REBEN_BISHER' | 'GEWAESSER_BISHER' | 'WYTWEIDE_UEBRIGE_BESTOCKTE' | 'WALD_BISHER' | 'WEIDWALD_BISHER' | 'UNKULTIVIERTES_GEBIET_BISHER' | 'UNBESTIMMT' | 'RUNDUNGSDIFFERENZ';
    export const BodenbedeckungArtEnum = {
        GEBAEUDE: 'GEBAEUDE' as BodenbedeckungArtEnum,
        BEFESTIGTSTRASSEWEG: 'BEFESTIGT_STRASSE_WEG' as BodenbedeckungArtEnum,
        BEFESTIGTTROTTOIR: 'BEFESTIGT_TROTTOIR' as BodenbedeckungArtEnum,
        BEFESTIGTVERKEHRSINSEL: 'BEFESTIGT_VERKEHRSINSEL' as BodenbedeckungArtEnum,
        BEFESTIGTBAHN: 'BEFESTIGT_BAHN' as BodenbedeckungArtEnum,
        BEFESTIGTFLUGPLATZ: 'BEFESTIGT_FLUGPLATZ' as BodenbedeckungArtEnum,
        BEFESTIGTWASSERBECKEN: 'BEFESTIGT_WASSERBECKEN' as BodenbedeckungArtEnum,
        BEFESTIGTUEBRIGEBEFESTIGTE: 'BEFESTIGT_UEBRIGE_BEFESTIGTE' as BodenbedeckungArtEnum,
        HUMUSIERTACKERWIESEWEIDE: 'HUMUSIERT_ACKER_WIESE_WEIDE' as BodenbedeckungArtEnum,
        HUMUSIERTINTENSIVKULTURREBEN: 'HUMUSIERT_INTENSIVKULTUR_REBEN' as BodenbedeckungArtEnum,
        HUMUSIERTINTENSIVKULTURUEBRIGEINTENSIVKULTUR: 'HUMUSIERT_INTENSIVKULTUR_UEBRIGE_INTENSIVKULTUR' as BodenbedeckungArtEnum,
        HUMUSIERTGARTENANLAGE: 'HUMUSIERT_GARTENANLAGE' as BodenbedeckungArtEnum,
        HUMUSIERTHOCHFLACHMOOR: 'HUMUSIERT_HOCH_FLACHMOOR' as BodenbedeckungArtEnum,
        HUMUSIERTUEBRIGEHUMUSIERTE: 'HUMUSIERT_UEBRIGE_HUMUSIERTE' as BodenbedeckungArtEnum,
        GEWAESSERSTEHENDES: 'GEWAESSER_STEHENDES' as BodenbedeckungArtEnum,
        GEWAESSERFLIESSENDES: 'GEWAESSER_FLIESSENDES' as BodenbedeckungArtEnum,
        GEWAESSERSCHILFGUERTEL: 'GEWAESSER_SCHILFGUERTEL' as BodenbedeckungArtEnum,
        BESTOCKTGESCHLOSSENERWALD: 'BESTOCKT_GESCHLOSSENER_WALD' as BodenbedeckungArtEnum,
        BESTOCKTWYTWEIDEWYTWEIDEDICHT: 'BESTOCKT_WYTWEIDE_WYTWEIDE_DICHT' as BodenbedeckungArtEnum,
        BESTOCKTWYTWEIDEWYTWEIDEOFFEN: 'BESTOCKT_WYTWEIDE_WYTWEIDE_OFFEN' as BodenbedeckungArtEnum,
        BESTOCKTUEBRIGEBESTOCKTE: 'BESTOCKT_UEBRIGE_BESTOCKTE' as BodenbedeckungArtEnum,
        VEGETATIONSLOSFELS: 'VEGETATIONSLOS_FELS' as BodenbedeckungArtEnum,
        VEGETATIONSLOSGLETSCHERFIRN: 'VEGETATIONSLOS_GLETSCHER_FIRN' as BodenbedeckungArtEnum,
        VEGETATIONSLOSGEROELLSAND: 'VEGETATIONSLOS_GEROELL_SAND' as BodenbedeckungArtEnum,
        VEGETATIONSLOSABBAUDEPONIE: 'VEGETATIONSLOS_ABBAU_DEPONIE' as BodenbedeckungArtEnum,
        VEGETATIONSLOSUEBRIGEVEGETATIONSLOSE: 'VEGETATIONSLOS_UEBRIGE_VEGETATIONSLOSE' as BodenbedeckungArtEnum,
        GEBAEUDEHOFRAUMGARTENANLAGEBISHER: 'GEBAEUDE_HOFRAUM_GARTEN_ANLAGE_BISHER' as BodenbedeckungArtEnum,
        STRASSEWEGTROTTOIRRAV: 'STRASSE_WEG_TROTTOIR_RAV' as BodenbedeckungArtEnum,
        BAHNENSTRASSENWEGEBISHER: 'BAHNEN_STRASSEN_WEGE_BISHER' as BodenbedeckungArtEnum,
        ACKERWIESEPFLANZLANDBAUMGARTENBISHER: 'ACKER_WIESE_PFLANZLAND_BAUMGARTEN_BISHER' as BodenbedeckungArtEnum,
        WEIDENBISHER: 'WEIDEN_BISHER' as BodenbedeckungArtEnum,
        REBENBISHER: 'REBEN_BISHER' as BodenbedeckungArtEnum,
        GEWAESSERBISHER: 'GEWAESSER_BISHER' as BodenbedeckungArtEnum,
        WYTWEIDEUEBRIGEBESTOCKTE: 'WYTWEIDE_UEBRIGE_BESTOCKTE' as BodenbedeckungArtEnum,
        WALDBISHER: 'WALD_BISHER' as BodenbedeckungArtEnum,
        WEIDWALDBISHER: 'WEIDWALD_BISHER' as BodenbedeckungArtEnum,
        UNKULTIVIERTESGEBIETBISHER: 'UNKULTIVIERTES_GEBIET_BISHER' as BodenbedeckungArtEnum,
        UNBESTIMMT: 'UNBESTIMMT' as BodenbedeckungArtEnum,
        RUNDUNGSDIFFERENZ: 'RUNDUNGSDIFFERENZ' as BodenbedeckungArtEnum
    };
}


